import { render, staticRenderFns } from "./ImageTextSetting.vue?vue&type=template&id=69c5380b&scoped=true&"
import script from "./ImageTextSetting.vue?vue&type=script&lang=js&"
export * from "./ImageTextSetting.vue?vue&type=script&lang=js&"
import style0 from "./ImageTextSetting.vue?vue&type=style&index=0&id=69c5380b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69c5380b",
  null
  
)

export default component.exports